import { useState } from 'react'
import Modal from './Modal'
import Boton from './Boton'
import api from '../api/client'
import { colors, text, space, radius } from '../design/tokens'

/**
 * Cambiar la propia contraseña. Hasta el alta masiva de usuarios (ago 2026)
 * esto no existía: la contraseña solo la cambiaba un administrador editando la
 * ficha, así que nadie podía cambiar la que le habían dado.
 *
 * Pide la actual a propósito: una sesión abierta en una máquina ajena no tiene
 * que alcanzar para dejar al dueño afuera.
 */
export default function ModalCambiarPassword({ onClose }) {
  const [form, setForm] = useState({ actual: '', nueva: '', nueva_confirmation: '' })
  const [guardando, setGuardando] = useState(false)
  const [error, setError] = useState('')
  const [listo, setListo] = useState(false)

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))

  const guardar = async (e) => {
    e.preventDefault()
    setError('')

    if (form.nueva !== form.nueva_confirmation) {
      setError('Las dos contraseñas nuevas no coinciden.')
      return
    }

    setGuardando(true)
    try {
      await api.post('/cambiar-password', form)
      setListo(true)
    } catch (err) {
      const errs = err.response?.data?.errors
      setError(errs ? Object.values(errs).flat().join(' ') : (err.response?.data?.message || 'No se pudo cambiar la contraseña.'))
    } finally {
      setGuardando(false)
    }
  }

  if (listo) {
    return (
      <Modal title="Contraseña cambiada" onClose={onClose}>
        <p style={{ fontSize: text.body, color: colors.text, marginBottom: space.lg }}>
          Listo. La próxima vez que entres, usá la contraseña nueva.
        </p>
        <p style={{ fontSize: text.sec, color: colors.textSec, marginBottom: space.lg }}>
          Si habías dejado la sesión abierta en otra computadora o en el celular,
          ahí se cerró: vas a tener que volver a entrar.
        </p>
        <Boton variante="primary" onClick={onClose}>Entendido</Boton>
      </Modal>
    )
  }

  return (
    <Modal title="Cambiar mi contraseña" onClose={onClose}>
      <form onSubmit={guardar} style={{ display: 'flex', flexDirection: 'column', gap: space.md }}>
        <Campo label="Contraseña actual" value={form.actual} onChange={set('actual')} autoFocus />
        <Campo label="Contraseña nueva" value={form.nueva} onChange={set('nueva')} ayuda="Mínimo 8 caracteres." />
        <Campo label="Repetí la nueva" value={form.nueva_confirmation} onChange={set('nueva_confirmation')} />

        {error && (
          <div style={{
            fontSize: text.sec, color: colors.err, background: colors.errBg,
            border: `1px solid ${colors.err}33`, borderRadius: radius.sm, padding: `${space.sm}px ${space.md}px`,
          }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: space.sm, justifyContent: 'flex-end', marginTop: space.sm }}>
          <Boton variante="ghost" type="button" onClick={onClose}>Cancelar</Boton>
          <Boton variante="primary" type="submit" disabled={guardando}>
            {guardando ? 'Guardando…' : 'Cambiar contraseña'}
          </Boton>
        </div>
      </form>
    </Modal>
  )
}

function Campo({ label, value, onChange, ayuda, autoFocus }) {
  return (
    <div>
      <label style={{ display: 'block', fontSize: text.sec, color: colors.textSec, marginBottom: 4 }}>{label}</label>
      <input
        type="password"
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        autoComplete="off"
        style={{
          width: '100%', padding: `${space.sm}px ${space.md}px`, fontSize: text.body,
          border: `1px solid ${colors.border}`, borderRadius: radius.sm,
        }}
      />
      {ayuda && <div style={{ fontSize: text.meta, color: colors.textMeta, marginTop: 3 }}>{ayuda}</div>}
    </div>
  )
}
